"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ItemProduct;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ChipStatus = require("../ChipStatus");

var _core = require("@material-ui/core");

var _constants = require("../utils/constants");

var _clsx = _interopRequireDefault(require("clsx"));

var _ImageThumbnail = _interopRequireDefault(require("../ImageThumbnail"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useStyle = (0, _core.makeStyles)(function (theme) {
  return {
    root: {
      display: "flex",
      width: "100%"
    },
    left: {
      fontSize: "small"
    },
    imageContainer: {
      padding: "2px"
    },
    productContainer: {
      width: "100%"
    },
    right: {
      textAlign: "right"
    },
    duplicate: {
      color: "darkgrey",
      fontSize: "smaller"
    },
    pointer: {
      cursor: "pointer"
    }
  };
});

function ItemProduct(_ref) {
  var brandName = _ref.brandName,
      label = _ref.label,
      id = _ref.id,
      status = _ref.status,
      image = _ref.image,
      mergeBrandName = _ref.mergeBrandName,
      mergeLabel = _ref.mergeLabel,
      mergeId = _ref.mergeId,
      onClick = _ref.onClick;
  var classes = useStyle();
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.root
  }, image && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.imageContainer
  }, /*#__PURE__*/_react["default"].createElement(_ImageThumbnail["default"], {
    src: image,
    alt: "".concat(brandName, " ").concat(label)
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])(classes.productContainer, onClick && classes.pointer),
    onClick: onClick && function () {
      return onClick();
    }
  }, status !== _constants.STATUS_BANNED ? /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.left
  }, /*#__PURE__*/_react["default"].createElement("span", null, brandName && "".concat(brandName, " ")), /*#__PURE__*/_react["default"].createElement("span", null, label), /*#__PURE__*/_react["default"].createElement("sup", null, "[", id, "]")), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.right
  }, /*#__PURE__*/_react["default"].createElement(_ChipStatus.ChipStatus, {
    code: status,
    label: status === _constants.productStatus.TRIVIAL ? "trivial" : status === _constants.productStatus.PSEUDO ? "pseudo" : null
  }))) : /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("strike", {
    className: classes.duplicate
  }, /*#__PURE__*/_react["default"].createElement("span", null, brandName, " "), /*#__PURE__*/_react["default"].createElement("span", null, label), /*#__PURE__*/_react["default"].createElement("sup", null, "[", id, "]")), mergeId && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", null, mergeBrandName, " "), /*#__PURE__*/_react["default"].createElement("span", null, mergeLabel), /*#__PURE__*/_react["default"].createElement("sup", null, "[", mergeId, "]")), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.right
  }, /*#__PURE__*/_react["default"].createElement(_ChipStatus.ChipStatus, {
    code: status
  })))));
}

ItemProduct.propTypes = {
  id: _propTypes["default"].number.isRequired,
  brand_name: _propTypes["default"].string,
  label: _propTypes["default"].string.isRequired,
  status: _propTypes["default"].number.isRequired,
  image: _propTypes["default"].string,
  mergeBrandName: _propTypes["default"].string,
  mergeLabel: _propTypes["default"].string,
  mergeId: _propTypes["default"].number,
  onClick: _propTypes["default"].func
};